import { useEffect, useState } from "react";

const TARGET = new Date("2026-10-03T17:00:00-06:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor(diff / 3600000) % 24],
    ["Minutes", Math.floor(diff / 60000) % 60],
    ["Seconds", Math.floor(diff / 1000) % 60],
  ];

  return (
    <div className="flex flex-wrap gap-3 md:gap-4" data-testid="countdown-timer">
      {units.map(([label, value]) => (
        <div
          key={label}
          className="border border-forest bg-moss px-4 md:px-6 py-3 md:py-4 text-center min-w-[74px] shadow-[4px_4px_0_0_#140C06]"
          data-testid={`countdown-${label.toLowerCase()}`}
        >
          <div className="font-display text-3xl md:text-4xl text-ember tabular-nums leading-none">
            {label === "Days" ? value : pad(value)}
          </div>
          <div className="font-body text-[10px] uppercase tracking-[0.25em] text-fog mt-2">{label}</div>
        </div>
      ))}
    </div>
  );
};
